const toastr = require("toastr");
var buttonClicked = false;

const Asaas = function(){
	var priv = { student: false, only_student: false };
  var pub = {};

  priv.disable_enable = function(name, enable) {
	  if (enable) {
		  $('#' + name).show();
		  var selectField = $('#' + name + ' select');
		  selectField.prop( "disabled", false );
		  //selectField.prop("selectedIndex", 0);
		  //selectField.focus().select();
	  } else {
		  var selectField = $('#' + name + ' select');
		  //selectField.prop("selectedIndex", 0);
		  selectField.prop("disabled", true );
		  $('#' + name).hide();
	  }
  }

  priv.switch_payment_method = function(e){
    priv.payment_method = e.currentTarget.value;

    if (e.currentTarget.value == 'credit_card'){
      $('#credit_card_row').show()
			priv.disable_enable('boleto_installment', false);
			priv.disable_enable('other_installment', false);
			priv.disable_enable('credit_card_installment', true);
    } else {
      $('#credit_card_row').hide()
	  	priv.disable_enable('credit_card_installment', false);
	  if (e.currentTarget.value == 'boleto_pix') {
	  	priv.disable_enable('boleto_installment', false);
  	  priv.disable_enable('other_installment', true);
	  } else {
	  	priv.disable_enable('other_installment', false);
			priv.disable_enable('boleto_installment', true);
	  }
    }

		// priv.calculate_discount();
  }

	// priv.calculate_discount = () => {
	// 	if (!priv.student) { $('#student_discount_show').hide(); return;; }

	// 	$('#student_discount_show').show();

	// 	let discount_percent = $('#displayStudentDiscount').data('discount');
	// 	let payment_method = $('#transaction_payment_method').select2('val');
	// 	let value = 0;
	// 	let valueText = '';

	// 	switch (payment_method) {
	// 		case 'credit_card':
	// 			valueText = $('#credit_card_installment').find('#transaction_payment_installment').find('option:selected')[0].text
	// 			value = parseFloat(valueText.split('(')[1].replace(')', '').replace('R$ ', '').replace(',', '.'))
	// 			break;

	// 		case 'boleto':
	// 			valueText = $('#boleto_installment').find('#transaction_payment_installment').find('option:selected')[0].text
	// 			value = parseFloat(valueText.split('(')[1].replace(')', '').replace('R$ ', '').replace(',', '.'))
	// 			break;

	// 		default:
	// 			valueText = $('#other_installment > h5').text()
	// 			value = parseFloat(valueText.replace('R$ ', '').replace(',', '.'))
	// 			break;
	// 	}

	// 	let discount_value = (value * (discount_percent / 100));
	// 	let total_value = value - discount_value;

	// 	$('label#displaySubtotal').text('R$ ' + value.toFixed(2).replace('.', ','))
	// 	$('label#displayStudentDiscount').text('R$ -' + discount_value.toFixed(2).replace('.', ','))
	// 	$('label#displayTotal').text('R$ ' + total_value.toFixed(2).replace('.', ','))
	// }

	priv.toogleCheckout = (show) => {
		if (show){
			$('.student_only_info').addClass('d-none');
			$('.paymentsMethods').removeClass('d-none');
			$('.form-actions').removeClass('d-none');
		} else {
			$('.student_only_info').removeClass('d-none');
			$('.paymentsMethods').addClass('d-none');
			$('.form-actions').addClass('d-none');
		}
	}

	priv.check_studant = function(e){
		let email = $('#transaction_person_attributes_email').val();
		let cpf_cnpj = $('#transaction_person_attributes_cpf_cnpj').val();

		const formKey = $('meta[name="rx54-safekey"]').attr("content");

		if (email.length > 10 && cpf_cnpj.length > 10){ 
			$.ajax({
				url: '/api/v2/students',
				dataType: 'json',
				headers: {
					'X-RX54-SECUREKEY': formKey
				},
				data: {
					email: email,
					cpf_cnpj: cpf_cnpj
				},
				type: "POST",
				success: () => { 
					priv.student = true;
					priv.toogleCheckout(true);
					// priv.calculate_discount();
				},
				error: () => { 
					priv.student = false;
					toastr.error('não encontramos você na base de alunos verifique os dados e tente novamente.', 'Oferta exclusiva para alunos!');
					priv.toogleCheckout(false);
					// $('#student_discount_show').hide();
				}
			})
		} else {
			priv.student = false;
			// toastr.error('Essa oferta é apenas para alunos!.', 'Erro!');
			// $('#student_discount_show').hide();
		}
	}

  priv.validateSubmit = function(e){
    e.preventDefault();
    e.stopPropagation();

		if (buttonClicked) {
			return false;
		}
		
		buttonClicked = true;

  	if ($('#transaction_person_attributes_name').val().trim().indexOf(" ") < 0) {
  		toastr.error('Campo nome, deve conter nome e sobrenome!.', 'Erro!');
			buttonClicked = false;
  		return false;
  	}
		
		if ($("[name$='[accepted]']:not(:checked)").filter("[type='checkbox']").length > 0){
			toastr.error('Você precisa concordar com os termos!.', 'Erro!');
			buttonClicked = false;
			return false;
		}

		if ($('#transaction_person_attributes_email').val().trim().length < 6) {
			toastr.error('Campo email, deve conter email!.', 'Erro!');
			buttonClicked = false;
			return false;
		
		}
		if ($('#transaction_person_attributes_cpf_cnpj').val().trim().length < 11) {
			toastr.error('Campo CPF/CNPJ, deve conter CPF/CNPJ válido!.', 'Erro!');
			buttonClicked = false;
			return false;
		}

		// console.log('É estudante', priv.only_student, !priv.student, (priv.only_student && !priv.student))
		if (priv.only_student && !priv.student) {
			toastr.error('Essa oferta é apenas para alunos!.', 'Erro!');
			buttonClicked = false;
			return false;
		}

		window.showToast([['sucess', 'Aguarde processando']]);
    // $('input#transaction_sender_hash').val(PagSeguroDirectPayment.getSenderHash());
    $('form').unbind('submit').trigger('submit');

    return false
  }

  pub.init = function(options){
    $('form').on('submit', priv.validateSubmit);

    $('#transaction_card_number').mask("0000 0000 0000 0000");
    $('#transaction_card_expiration').mask("00/0000");
    $('#transaction_person_attributes_birth_at').mask("00/00/0000");
    $('#transaction_payment_method').on('change', priv.switch_payment_method).trigger('change');
		$('#transaction_card_expiration').blur(function() {
			var exp = $('#transaction_card_expiration').val();
			if (exp.length < 7) {
				$('#transaction_card_expiration').val(exp.replace("/","/20"));
			}
		});

		$('#btn_help')[0].href = $('#btn_help')[0].href.replace('http://help/?', atob("aHR0cHM6Ly93YS5tZS81NTU0OTE0Njg4MTU/dGV4dD0="));
		// $('#transaction_payment_installment').on('change', priv.calculate_discount);

		if (options.only_student){
			priv.only_student = true
			
			$(document).on("ready page:load turbolinks:load", () => { setTimeout(priv.check_studant(), 100) });

			$('#transaction_person_attributes_email').on('blur', priv.check_studant);
			$('#transaction_person_attributes_cpf_cnpj').on('blur', priv.check_studant);
		}
  }

  return pub;
}()

export default Asaas;
